export default "__VITE_ASSET__4db15cb4__"